export const AYANA_KOMODO_FACEBOOK = "https://www.facebook.com/AYANAKomodo/";
export const AYANA_KOMODO_YOUTUBE = "https://www.youtube.com/user/ayanaresort";
export const AYANA_KOMODO_TRIPADVISOR =
  "https://www.tripadvisor.com/Hotel_Review-g1777483-d14167975-Reviews-AYANA_Komodo_Resort-Labuan_Bajo_Flores_East_Nusa_Tenggara.html";
export const AYANA_KOMODO_TIKTOK =
  "https://www.tiktok.com/@ayanahotels?lang=en";
export const AYANA_BALI_WHATSAPP_LINK =
  "https://api.whatsapp.com/send?phone=6281138202288&text=Hi%20Ayana%20Bali";
export const AYANA_ROCKBAR_BALI_WHATSAPP_LINK =
  "https://api.whatsapp.com/send?phone=6281138100083&text=Hi%20Rock%20Bar";
export const AYANA_KOMODO_WHATSAPP_LINK =
  "https://api.whatsapp.com/send?phone=+6281138202288&text=Hi%20Ayana%20Komodo";
export const AYANA_JAKARTA_WHATSAPP_LINK =
  "https://api.whatsapp.com/send?phone=+6282125277531&text=Hi%20Ayana%20Jakarta";
